<script setup>
import OverlayPanel from "primevue/overlaypanel";
import {ref} from "vue";

const props = defineProps([
    'deviceReasonsMap',
]);

const currentDeviceReasons = ref(null)
const op = ref(null)

const togglePopOver = (e, device) => {
    if (typeof props.deviceReasonsMap[device.name] == 'undefined' ||
        typeof props.deviceReasonsMap[device.name][device.pivot.warning_type] == 'undefined') {
        return
    }

    currentDeviceReasons.value = props.deviceReasonsMap[device.name][device.pivot.warning_type]

    op.value.toggle(e)
}

defineExpose({
    togglePopOver
})

</script>
<template>
    <OverlayPanel ref="op">
        <div class="w-[25rem]">
            <div v-if="currentDeviceReasons" class="flex flex-col gap-y-2">
                <div v-for="(data, i) in currentDeviceReasons">
                    <h4 class="text-sm">{{ data.title }}</h4>

                    <ul v-if="data?.items" class="text-xs list-disc pl-[20px]">
                        <li v-for="itemValue in data.items">{{ itemValue }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </OverlayPanel>
</template>
